import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ZardButtonComponent } from '@solvace/zard/shared/components/button';
import { ZardDialogRef } from '@solvace/zard/shared/components/dialog/dialog-ref';
import { Z_MODAL_DATA } from '@solvace/zard/shared/components/dialog/dialog.service';

export interface SvzCopilotConfirmDialogData {
  text: string;
  title?: string;
  okText?: string;
  cancelText?: string;
  hideCloseButton?: boolean;
}

@Component({
  selector: 'svz-copilot-confirm-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ZardButtonComponent],
  templateUrl: './svz-copilot-confirm-dialog.component.html',
})
export class SvzCopilotConfirmDialogComponent {
  private readonly dialogRef = inject(ZardDialogRef<SvzCopilotConfirmDialogComponent, boolean | undefined>);
  private readonly data = inject<SvzCopilotConfirmDialogData>(Z_MODAL_DATA);

  protected readonly title = this.data?.title ?? 'Atenção';
  protected readonly text = this.data?.text;
  protected readonly okText = this.data?.okText ?? 'Sim';
  protected readonly cancelText = this.data?.cancelText ?? 'Cancelar';
  protected readonly hideCloseButton = this.data?.hideCloseButton ?? false;

  ok(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
